"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketEncryptionInput_1 = require("./GetBucketEncryptionInput");
var GetBucketEncryptionOutput_1 = require("./GetBucketEncryptionOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketEncryption = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketEncryption",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?encryption"
    },
    input: {
        shape: GetBucketEncryptionInput_1.GetBucketEncryptionInput
    },
    output: {
        shape: GetBucketEncryptionOutput_1.GetBucketEncryptionOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketEncryption.js.map